import 'whatwg-fetch';

export default class Disclosure {
  constructor(element) {
    this.classes = {
      listVisible: 'disclosure-list--visible',
    };

    this.container = element;
    this.disclosureList = this.container.querySelector('[data-disclosure-list]');
    this.disclosureToggle = this.container.querySelector('[data-disclosure-toggle]');
    this.disclosureInput = this.container.querySelector('[data-disclosure-input]');
    this.disclosureOptions = this.container.querySelectorAll('[data-disclosure-option]');
    this.disclosureForm = this.container.parentNode.parentNode;

    this.connectOptions();
    this.connectToggle();
    this.onFocusOut();
  }

  connectToggle() {
    this.disclosureToggle.addEventListener('click', e => {
      e.preventDefault();

      const ariaExpanded = this.disclosureToggle.getAttribute('aria-expanded') === 'true';
      this.disclosureToggle.setAttribute('aria-expanded', !ariaExpanded);

      if (!ariaExpanded) {
        this.disclosureList.classList.add(this.classes.listVisible);
      } else {
        this.disclosureList.classList.remove(this.classes.listVisible);
      }
    });
  }

  connectOptions() {
    this.disclosureOptions.forEach(option => {
      option.addEventListener('click', e => {
        e.preventDefault();

        this.disclosureInput.value = e.currentTarget.dataset.value;
        this.disclosureForm.submit();
      });
    });
  }

  onFocusOut() {
    this.container.addEventListener('keyup', e => {
      // escape
      if (e.which !== 27) return;
      this.hideList();
      this.disclosureToggle.focus();
    });

    document.body.addEventListener('click', e => {
      const isOption =
        e.target.classList.contains('disclosure-list__item') ||
        e.target.classList.contains('disclosure__toggle');
      const isVisible = this.disclosureList.classList.contains(this.classes.listVisible);

      if (isVisible && !isOption) {
        this.hideList();
      }
    });
  }

  hideList() {
    this.disclosureList.classList.remove(this.classes.listVisible);
    this.disclosureToggle.setAttribute('aria-expanded', false);
  }
}
